import { useSelector } from 'react-redux';
import { getSearchQueryParams } from '~/selectors';

function useForceError() {
  const queryParams = useSelector(getSearchQueryParams);

  return queryParams['vdp-break-spinner']
    ? () =>
        // prettier-ignore
        // @ts-ignore
        ({}).foo.bar
    : null;
}

export default useForceError;
